import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  singleCard: {
    marginBottom: 5,
  },
  webMultiCardContainer: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'stretch',
  },
  carouselItem: {
    width: 350,
    minWidth: 0,
    marginRight: 10,
    marginLeft: 10,
  },
  carouselContentContainer: {
    gap: 0,
    paddingLeft: 0,
  },
});
